import { MoneySizeStyles } from './moneyRendererV3.types';

export const sizeStyles: MoneySizeStyles = {
  extraSmall: {
    cents: { fontSize: '0.6em', verticalAlign: 'top' },
    principal: { fontSize: 10, fontWeight: 400 },
    promotion: { fontSize: 8, fontWeight: 400, textDecoration: 'line-through' },
  },
  small: {
    cents: { fontSize: '0.6em', verticalAlign: 'top' },
    principal: { fontSize: 12, fontWeight: 400 },
    promotion: {
      fontSize: 10,
      fontWeight: 400,
      textDecoration: 'line-through',
    },
  },
  medium: {
    cents: { fontSize: '0.6em', verticalAlign: 'top' },
    principal: { fontSize: 14, fontWeight: 400 },
    promotion: {
      fontSize: 12,
      fontWeight: 400,
      textDecoration: 'line-through',
    },
  },
  large: {
    cents: { fontSize: '0.6em', verticalAlign: 'top' },
    principal: { fontSize: 16, fontWeight: 400 },
    promotion: {
      fontSize: 12,
      fontWeight: 400,
      textDecoration: 'line-through',
    },
  },
};
